import { rasterSrc } from "@/generated/raster-images";
import { createFileRoute } from "@tanstack/react-router";

import { PageHero, Section, SectionHeader, ServicesGrid, CTABand } from "@/components/site-blocks";
import { EnquiryForm } from "@/components/enquiry-form";
import { SolarFinanceEligibility } from "@/components/solar-finance-eligibility";
import { FINANCE_SERVICES_HUB_COPY } from "@/content/landing/financing";
import {
  SERVICES_BY_CATEGORY,
  CATEGORY_LABELS,
  CATEGORY_ORDER,
  CATEGORY_DESCRIPTIONS,
} from "@/lib/services";
import { pageSeo } from "@/lib/seo";

export const Route = createFileRoute("/services")({
  head: () => ({
    ...pageSeo({
      path: "/services",
      title: "Insulation, Damp, Heating & Renewables Services | CRS Energy",
      description:
        "Cavity wall removal, loft & wall insulation, damp remediation, ventilation, boilers, heat pumps and solar PV by CRS Energy in Wales & the South West.",
    }),
  }),
  component: ServicesHub,
});

function ServicesHub() {
  return (
    <>
      <PageHero
        eyebrow="Services"
        title="Every measure your property needs"
        description="From cavity wall insulation removal to solar PV installation, CRS delivers the full retrofit and remediation toolkit. Each service surveyed, specified and installed by accredited specialist teams."
        image={rasterSrc("stock/photo-1581094288338-2314dddb7ece")}
        imageAlt="Insulation install in progress"
      />


      {CATEGORY_ORDER.map((category, idx) => (
        <Section key={category} className={idx % 2 === 1 ? "bg-card" : undefined} id={category}>
          <SectionHeader
            eyebrow={`Category ${idx + 1} of ${CATEGORY_ORDER.length}`}
            title={CATEGORY_LABELS[category]}
            description={CATEGORY_DESCRIPTIONS[category]}
          />
          <ServicesGrid services={SERVICES_BY_CATEGORY[category]} />
        </Section>
      ))}

      <SolarFinanceEligibility
        sourcePage="/services"
        bodyCopy={FINANCE_SERVICES_HUB_COPY}
      />

      <CTABand
        title="Not sure where to start?"
        description="Book a survey and we'll recommend the right scope for your property."
        variant="primary"
      />

      <span id="contact" aria-hidden className="block scroll-mt-24" />
      <Section>
        <div className="container-page max-w-3xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-2">
              Book A Free Survey
            </h2>
            <p className="text-sm md:text-base text-muted-foreground">
              Tell us what you need and we&apos;ll arrange a no-obligation assessment.
            </p>
          </div>
          <div className="rounded-2xl border border-border bg-card p-5 sm:p-6 md:p-8 shadow-soft">
            <EnquiryForm
              formType="survey"
              variant="survey"
              sourcePage="/services"
              submitLabel="Submit"
            />
          </div>
        </div>
      </Section>
    </>
  );
}
